import icon from "../../assets/keyfob.svg";
import type { Property } from "../../types";

export const nfcCard: Property = {
  id: "nfcCard",
  title: "nfcCard.title",
  icon,
};
